import React, {FC} from "react";

interface NFTTradesProps {
}

const NFTTrades: FC<NFTTradesProps> = (props) => {

    return (
        <div className="bs-card p-5">
            <h1>Missing</h1>
        </div>
    );
};

export default NFTTrades;
